<template>
    <div class="row">
        <b-col sm="6">
            <div
                :class="{
                    domainvalues:
                        filter.domainType === domainTypeConst.ALL_VALUES
                }"
            >
                <!-- Checkbox+label -->
                <x-checkbox
                    :id="`checkbox-${componentId}_${filter.id}`"
                    :name="`checkbox-${componentId}_${filter.id}`"
                    :value="filter.selected"
                    plain
                    :indeterminate="isIndeterminate"
                    :text="filter.name"
                    @change="$_onSelectFilter($event)"
                    @click.stop=""
                >
                </x-checkbox>
                <!-- Domein alle waarden -->
                <div
                    class="col ml-4 mb-2"
                    v-if="
                        filter.feedbackDomain &&
                        filter.feedbackDomain.keyvalues &&
                        filter.domainType === domainTypeConst.ALL_VALUES
                    "
                >
                    <div
                        v-for="keyvalue in filter.feedbackDomain.keyvalues"
                        :key="keyvalue.id"
                        class="row"
                    >
                        <x-checkbox
                            :id="`${componentId}_${filter.id}${keyvalue.id}`"
                            :name="`${componentId}_${filter.id}${keyvalue.id}`"
                            :value="filter.value.indexOf(keyvalue.value) > -1"
                            plain
                            @change="$_toggleFilterValue($event, keyvalue.key)"
                            :disabled="filter.disabled"
                            :text="keyvalue.value"
                        >
                        </x-checkbox>
                    </div>
                </div>
            </div>
        </b-col>
        <b-col
            class="filtervalue"
            v-show="filter.domainType !== domainTypeConst.ALL_VALUES"
        >
            <!-- Operator -->
            <x-select
                v-if="filter.operatorEditable"
                :id="`filterOperators${filter.id}`"
                :name="`filterOperators${filter.id}`"
                v-model="filter.operator"
                :options="$_filterOperatorOptions(filter)"
                :simpleMode="true"
                :disabled="filter.unavailable"
            >
            </x-select>
            <!-- Invoer veld -->
            <x-input
                v-if="!filter.domainId || filter.domainId === 0"
                :id="`filterInput${componentId}_${filter.id}`"
                :name="`filterInput${componentId}_${filter.id}`"
                :smt-ng-filter-input="filter.id"
                class="filterwaarde"
                :state="valid"
                :invalidMessage="invalidFieldError"
                v-model="filter.value"
                :justInvalidState="true"
                :plaintext="filter.disabled"
                :placeholder="
                    filter.valueInput === valueInputConst.DATEFIELD
                        ? 'dd-mm-jjjj'
                        : ''
                "
                :maxlength="$_getMaxInputChars(filter)"
            >
            </x-input>
            <!-- Domein keuzelijst -->
            <x-select
                v-if="
                    filter.feedbackDomain &&
                    filter.feedbackDomain.keyvalues &&
                    filter.domainType === domainTypeConst.DROPDOWNLIST
                "
                :id="`filterInput${componentId}_${filter.id}`"
                :name="`filterInput${componentId}_${filter.id}`"
                :smt-ng-filter-input="filter.id"
                :disabled="filter.disabled"
                :extendedClass="{ plaintext: filter.disabled }"
                :textDefaultOption="$t('emptyValue')"
                :simpleMode="true"
                v-model="filter.value"
                :options="$_getDomainValues(filter.feedbackDomain.keyvalues)"
            >
            </x-select>
            <!-- Domein suggestielijst -->
            <x-datalist
                v-if="
                    filter.feedbackDomain &&
                    filter.feedbackDomain.keyvalues &&
                    filter.domainType === domainTypeConst.SUGGESTIONLIST
                "
                :id="`filterInput${componentId}_${filter.id}`"
                :name="`filterInput${componentId}_${filter.id}`"
                :smt-ng-filter-input="filter.id"
                :plaintext="filter.disabled"
                :state="valid"
                :invalidMessage="invalidFieldError"
                :options="$_getDomainValues(filter.feedbackDomain.keyvalues)"
                v-model="filter.domainKeyValue"
                class="filterwaarde"
                @change="$_validateFieldValue()"
                :simpleMode="true"
                autocomplete="off"
            >
            </x-datalist>
        </b-col>
    </div>
</template>

<script>
    import { DOMAIN_TYPE, VALUE_INPUT_TYPE } from '../../../../constants';
    import {
        removeXmlPrefix,
        arraySortAscendingFunction,
        filterOperatorOptions
    } from '../../../../services/utilities';
    import {
        validateDate,
        validateNumber,
        validateBoolean
    } from '../../../../services/utilities/validator';
    import { expandFilterValue } from '../../../../services/map/filter';

    export default {
        props: {
            filterData: { type: Object, required: true },
            layerId: { type: [Number, String], required: true },
            overrideSelected: { type: Boolean }
        },
        data: function () {
            return {
                domainTypeConst: DOMAIN_TYPE,
                valueInputConst: VALUE_INPUT_TYPE,
                filter: null,
                valid: true,
                invalidFieldError: '',
                componentId: this._uid
            };
        },
        watch: {
            filterData: {
                handler: function (newVal) {
                    this.filter = { ...newVal };
                    if (this.filter.domainType === DOMAIN_TYPE.ALL_VALUES) {
                        if (!Array.isArray(this.filter.value)) {
                            this.filter.value = [];
                        }
                    }
                    this.filter.value = expandFilterValue(this.filter.value);
                },
                immediate: true
            },
            'filter.value': function (newVal) {
                this.$_setSelectedValue(this.filter, newVal);
                this.$_updatedFilter();
            },
            'filter.domainKeyValue': function (newVal) {
                this.$_setSelectedValue(this.filter, newVal);
                this.$_updatedFilter();
            },
            'filter.selected': function () {
                this.$_updatedFilter();
            },
            'filter.operator': function () {
                this.$_updatedFilter();
            },
            overrideSelected(newVal) {
                if (newVal !== null) {
                    this.filter.selected = newVal;
                    if (
                        this.filter.feedbackDomain &&
                        this.filter.domainType === DOMAIN_TYPE.ALL_VALUES
                    ) {
                        this.filter.feedbackDomain.keyvalues.forEach((keyValue) => {
                            this.$_toggleFilterValue(newVal, keyValue.value);
                        });
                    }
                }
            }
        },
        computed: {
            hasValue: function () {
                return this.filter.value?.length > 0;
            },
            isIndeterminate: function () {
                return (
                    this.filter.domainType === DOMAIN_TYPE.ALL_VALUES &&
                    this.hasValue &&
                    this.filter.value.length <
                        this.filter.feedbackDomain.keyvalues.length
                );
            }
        },
        methods: {
            $_setSelectedValue(filter, value) {
                // automatically check/uncheck checkbox depending on value
                // use double negation to check if value is null or empty
                if (filter.domainType !== DOMAIN_TYPE.ALL_VALUES) {
                    filter.selected = !!value;
                }
            },
            $_getDomainValues(keyvalues) {
                const values = [];
                keyvalues.forEach((item) => {
                    values.push({
                        value: item.key,
                        text: item.value
                    });
                });
                return values.sort(arraySortAscendingFunction('text'));
            },
            $_toggleFilterValue(active, value) {
                const domainValues = this.filter.value.filter(
                    (val) => val !== value
                );
                if (active) {
                    domainValues.push(value);
                }
                // make sure there are nou doubles
                this.filter.value = [...new Set(domainValues)];
                // select filter when at least one is selected
                this.filter.selected = this.filter.value.length > 0;
            },
            $_onSelectFilter(active) {
                if (this.filter.domainType === DOMAIN_TYPE.ALL_VALUES) {
                    this.filter.value = active
                        ? this.filter.feedbackDomain.keyvalues.map(
                              ({ value }) => value
                          )
                        : [];
                }
                this.filter.selected = active;
            },
            // eslint-disable-next-line complexity
            $_validateFieldValue() {
                // Clear error
                this.valid = true;
                this.invalidFieldError = '';

                // No validation on inactive filters
                if (!this.filter.selected) {
                    return;
                }

                // Validation on domainvalues in suggestionlist (no validation on empty values)
                if (
                    this.filter.domainId &&
                    this.filter.domainType === DOMAIN_TYPE.SUGGESTIONLIST
                ) {
                    if (!this.filter.domainKeyValue) {
                        this.filter.value = '';
                    } else {
                        const foundDomain =
                            this.filter.feedbackDomain.keyvalues.find((d) => {
                                return (
                                    d.value.toLowerCase() ===
                                    this.filter.domainKeyValue.toLowerCase()
                                );
                            });
                        if (foundDomain) {
                            this.filter.value = foundDomain.key;
                        } else {
                            this.invalidFieldError =
                                'Dit veld heeft geen geldige waarde (kies een waarde uit de lijst)';
                            this.valid = false;
                        }
                    }
                }

                // No validation on domainvalues
                if (!this.filter.domainId) {
                    const filteredDataType = removeXmlPrefix(this.filter.dataType);
                    switch (filteredDataType) {
                        case 'string':
                            // All entries are allowed
                            break;
                        case 'boolean':
                            if (!validateBoolean(this.filter.value)) {
                                this.invalidFieldError =
                                    'Dit veld bevat geen geldige waarde';
                                this.valid = false;
                            }
                            break;
                        case 'int':
                        case 'byte':
                        case 'integer':
                        case 'negativeInteger':
                        case 'long':
                        case 'float':
                        case 'double':
                        case 'decimal':
                            if (!validateNumber(this.filter.value)) {
                                this.invalidFieldError =
                                    'Dit veld bevat geen geldige numeriek waarde';
                                this.valid = false;
                            }
                            break;
                        case 'date':
                        case 'dateTime':
                        case 'time':
                            if (!validateDate(this.filter.value)) {
                                this.invalidFieldError =
                                    this.$t('labelInvalidDate');
                                this.valid = false;
                            }
                            break;
                    }
                }
            },
            $_getMaxInputChars() {
                return 100;
            },
            $_updatedFilter() {
                if (
                    this.filter.domainType === DOMAIN_TYPE.ALL_VALUES &&
                    this.filter.value.length ===
                        this.filter.feedbackDomain.keyvalues.length
                ) {
                    this.filter.selected = true;
                }
                this.$_validateFieldValue();
                if (this.valid) {
                    this.$emit('update', { ...this.filter });
                }
            },
            $_filterOperatorOptions(filter) {
                return filterOperatorOptions(filter);
            }
        }
    };
</script>

<style>
.filtervalue .form-group {
    margin-bottom: 5px;
}
</style>
